const styles = (theme) => ({
  formControlLabel: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    width: '50%',
    maxWidth: 250,
    border: `1px solid ${theme.palette.primary.dark}`,
    borderRadius: `0 ${theme.variables.borderRadius}px ${theme.variables.borderRadius}px 0`,
    textAlign: 'center',
    '&:first-of-type': {
      border: `1px solid ${theme.palette.primary.dark}`,
      borderRight: 'none',
      borderRadius: `${theme.variables.borderRadius}px 0 0 ${theme.variables.borderRadius}px`,
    },
  },
  radioGroupButtons: {
    '& svg': {
      display: 'none',
    },
  },
  radioButton: {
    /* Make radio button itself visually hidden */
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: 1,
    margin: 0,
    '& + span': {
      width: '100%',
      minHeight: 43,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.text.dark,
      fontWeight: 500,
    },
  },
  radioButtonChecked: {
    '& + span': {
      color: theme.palette.text.white,
      background: theme.palette.primary.dark,
    },
  },
  buttonFocused: {
    outline: `auto ${theme.spacing.unit * 0.25}px ${
      theme.palette.primary.light
    }`,
  },
});

export default styles;
